// extracted by mini-css-extract-plugin
module.exports = {"top-spacing":"_38LnBIaPNNou57t6BmhJ","top-padding":"_3TKzFaSqu1Nqdgn-F4Bn","children-gutter-x":"_1cH6h1JqflIU_NRWHYUP","children-gutter-y":"_2BEXeWEYx00ATX8qUVsh"};